import { render, staticRenderFns } from "./FilmListItem.vue?vue&type=template&id=fd09f7b6&scoped=true&"
import script from "./FilmListItem.vue?vue&type=script&lang=js&"
export * from "./FilmListItem.vue?vue&type=script&lang=js&"
import style0 from "./FilmListItem.vue?vue&type=style&index=0&id=fd09f7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd09f7b6",
  null
  
)

component.options.__file = "FilmListItem.vue"
export default component.exports